import React from 'react';

function SuccessModal({ isOpen, onClose }) {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <style>{`
        .success-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 20px;
        }

        .success-modal-container {
          background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
          border-radius: 24px;
          padding: 50px 40px;
          width: 100%;
          max-width: 500px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
          position: relative;
          text-align: center;
        }

        .success-modal-icon {
          font-size: 80px;
          margin-bottom: 24px;
          color: #4cd964;
        }

        .success-modal-title {
          font-size: 32px;
          font-weight: 700;
          color: #ffffff;
          font-family: 'Outfit', sans-serif;
          margin-bottom: 16px;
        }

        .success-modal-text {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          font-family: 'Inter', sans-serif;
          line-height: 1.6;
          margin-bottom: 32px;
        }

        .success-modal-button {
          width: 100%;
          padding: 18px 32px;
          background: #d6ab78;
          color: #ffffff;
          border: none;
          border-radius: 12px;
          font-size: 18px;
          font-weight: 600;
          font-family: 'Inter', sans-serif;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .success-modal-button:hover {
          background: #c49a67;
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(214, 171, 120, 0.4);
        }
      `}</style>
      <div 
        className="success-modal-overlay" 
        onClick={onClose}
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2000
        }}
      >
        <div className="success-modal-container" onClick={(e) => e.stopPropagation()}>
          <div className="success-modal-icon">✓</div>
          <h2 className="success-modal-title">Inscription réussie !</h2>
          <p className="success-modal-text">
            Merci pour votre intérêt ! Nous vous contacterons très prochainement 
            pour vous donner accès à HEYA en avant-première.
          </p>
          <button
            className="success-modal-button"
            onClick={onClose}
          >
            Parfait
          </button>
        </div>
      </div>
    </>
  );
}

export default SuccessModal;
